import { getCardInstance } from "../selectors/card-instances";
import { calculateEventLimit } from "../selectors/event-limit";
import type { DisbandCommanderAction, GameEvent, SetupGameState } from "../types";
import type { TransitionResult } from "./advance-phase";

function eventId(actionSequence: number, ordinal: number): string {
  return `event-${actionSequence}-${ordinal}`;
}

export function applyDisbandCommander(
  state: Readonly<SetupGameState>,
  action: DisbandCommanderAction,
  actionSequence: number,
): TransitionResult {
  const instance = getCardInstance(state, action.commanderCardInstanceId);
  if (instance === undefined) {
    throw new Error("Validated Commander disband unexpectedly lost its card-instance record.");
  }

  const lane = state.lanes[action.laneId];
  const side = lane.players[action.playerId];
  const eventLimitBefore = calculateEventLimit(state, action.playerId);
  const nextState: SetupGameState = {
    ...state,
    players: {
      ...state.players,
      [action.playerId]: {
        ...state.players[action.playerId],
        discard: [...state.players[action.playerId].discard, action.commanderCardInstanceId],
      },
    },
    lanes: {
      ...state.lanes,
      [action.laneId]: {
        ...lane,
        players: {
          ...lane.players,
          [action.playerId]: {
            ...side,
            commander: null,
          },
        },
      },
    },
  };
  const event: GameEvent = {
    type: "commander-disbanded",
    eventId: eventId(actionSequence, 0),
    actionSequence,
    playerId: action.playerId,
    laneId: action.laneId,
    commanderCardInstanceId: action.commanderCardInstanceId,
    cardDefinitionId: instance.cardDefinitionId,
    destination: "discard",
    remainingArmyCardInstanceIds: side.armies.map((army) => army.cardInstanceId),
    eventLimitBefore,
    eventLimitAfter: calculateEventLimit(nextState, action.playerId),
  };

  return { state: nextState, events: [event] };
}
